import React from 'react'
import get from 'lodash/get'
import { graphql } from 'gatsby'

import Layout from '../layouts/layoutNoBG'
import PostPreview from '../components/PostPreview'
import Seo from '../components/SEO'
import Pagination from '../components/Pagination'
import { getPostsPageUrl } from '../utils/routing'
import Banner from '../components/Banner'
import { useTelegramSignIn } from '../components/TelegramSignIn'

const IndexPage = (props) => {
  const posts = get(props, 'data.allMarkdownRemark.edges')
  const pagesTotal = get(props, 'pageContext.pagesTotal')
  const currentPage = get(props, 'pageContext.currentPage')
  const pageURL = getPostsPageUrl(currentPage) // currentPage > 1 ? `/pages/${currentPage}` : '/'
  useTelegramSignIn()
  return (
    <Layout>
      <Seo url={pageURL} />
      <Banner />
      {posts.map(({ node }, i) => (
        <PostPreview key={`post-${i}`} post={node} />
      ))}
      <Pagination
        currentPage={currentPage}
        pagesTotal={pagesTotal}
        getPageUrl={getPostsPageUrl}
      />
    </Layout>
  )
}

export default IndexPage

export const pageQuery = graphql`
  query ($pageSize: Int, $pageSkip: Int) {
    allMarkdownRemark(
      limit: $pageSize
      skip: $pageSkip
      sort: { frontmatter: { date: DESC } }
      filter: { frontmatter: { hideInHomePages: { ne: true } } }
    ) {
      edges {
        node {
          fields {
            slug
          }
          frontmatter {
            excerpt
            date(formatString: "YYYY MoDo", locale: "zh-cn")
            title
            tags
            featuredImage {
              childImageSharp {
                gatsbyImageData(width: 180, layout: CONSTRAINED)
              }
            }
          }
        }
      }
    }
  }
`
